//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _TenantSwitcherMenuItem from './TenantSwitcherMenuItem';
export const TenantSwitcherMenuItem = _TenantSwitcherMenuItem;
export default {TenantSwitcherMenuItem};

